import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { SystemIcon } from '@helpers/icons';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import FiltersFormStyles from '@stories/Components/Misc/FiltersForm/FiltersForm.styles';
import styled from 'styled-components';
const Container = styled(FiltersFormStyles.Container) ``;
const ButtonWrapper = styled.div `
  display: flex;
  gap: 24px;
  margin-top: ${fluid(0, 24)};

  ${ButtonStyles.Container}[data-icon-type=${SystemIcon.None}] {
    --borderColour: transparent;
  }

  ${ButtonStyles.Container}[type='submit'] {
    --borderColour: ${brand.blue.default};
  }
`;
const SavingsProductFiltersStyles = {
    Container,
    ButtonWrapper,
};
export default SavingsProductFiltersStyles;
